import { defaultTheme } from "../../shared/constants";
import { styled } from "styled-components";

export const InputWithIcon = styled.div`
  &.inputWithIcon {
    position: relative;
  }
  input {
    padding-left: 34px;
    border: 0;
    outline: 0;
    background: transparent;
    border-bottom: 1px solid ${defaultTheme.COLORS.GRAY_MEDIUM};
    border-radius: 0px;
  }

  input:focus {
    border: 0px;
    border-bottom: 1px solid ${defaultTheme.COLORS.GRAY_BLACK};
  }

  .left-icon {
    position: absolute;
    left: 0px;
    top: 50%;
    transform: translateY(-50%);
  }
`;
